import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserService } from '@/services';
import type { UserCourseStatus } from '@/types';

export function useUpdatePlannedFinishDate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ courseId, date }: { courseId: string; date: string }) => {
      const { plannedToFinishAt } = await UserService.updatePlannedFinishDate(courseId, date);
      return plannedToFinishAt;
    },
    onSuccess: (plannedToFinishAt) => {
      queryClient.setQueryData(['userCourseStatus'], (state: UserCourseStatus) => ({
        ...state,
        plannedToFinishAt,
      }));
    },
  });
}
